/**
 * Resolve a display string for an engine state path, with a LEAF FALLBACK.
 *
 * Look up `<prefix>.<full.dotted.path>` first, then `<prefix>.<leaf>`, then the
 * caller's fallback.
 *
 * Two lookups rather than one because compound nesting is an AUTHORING choice
 * that says nothing about what a step IS. The same consent step is
 * `data_collection.awaiting_consent` in one template and `awaiting_consent` in
 * another; forking a template or compiling a country segment under a new parent
 * moves it again. Keying only on the full path means every such flow renders a
 * raw dotted key at the applicant — the one reader who cannot be expected to
 * know what `data_collection.awaiting_consent` means.
 *
 * Full path wins, so a flow that genuinely needs different copy for two states
 * sharing a leaf name can still say so.
 */
export type Translate = (key: string, opts: { defaultValue: string }) => string;

export function translateState(
  t: Translate,
  prefix: string,
  state: string | null,
  fallback: string,
): string {
  if (!state) return fallback;
  const leaf = state.slice(state.lastIndexOf('.') + 1);
  const byLeaf = leaf === state ? fallback : t(`${prefix}.${leaf}`, { defaultValue: fallback });
  return t(`${prefix}.${state}`, { defaultValue: byLeaf });
}
